// Detect tech stack của folder qua signature file ở root. Trả về tất cả stack
// match được (folder polyglot là chuyện thường — vd monorepo Node + Python).
// Nếu không match gì → ["generic"].
import { existsSync } from "node:fs";
import { join } from "node:path";

export type TechStack = "node" | "python" | "go" | "rust" | "java" | "ruby" | "generic";

// Bảng signature: stack → các file đủ điều kiện claim stack đó.
const SIGNATURES: Record<Exclude<TechStack, "generic">, string[]> = {
  node: ["package.json"],
  python: ["pyproject.toml", "requirements.txt", "setup.py", "Pipfile"],
  go: ["go.mod"],
  rust: ["Cargo.toml"],
  java: ["pom.xml", "build.gradle", "build.gradle.kts"],
  ruby: ["Gemfile"],
};

export function detectFolderTechStack(folderPath: string): TechStack[] {
  const matched: TechStack[] = [];
  for (const [stack, files] of Object.entries(SIGNATURES) as [
    Exclude<TechStack, "generic">,
    string[],
  ][]) {
    if (files.some((f) => existsSync(join(folderPath, f)))) {
      matched.push(stack);
    }
  }
  return matched.length > 0 ? matched : ["generic"];
}
